<footer>
    <div class="content-wrapper">
        <div class="float-left">
            <app-version></app-version>
            <p>&copy; {{currentYear}} {{'ChevronCorporationAllrightsreserved' | translate}}</p>
        </div>
    </div>
</footer>
